import gsap from "gsap";

import { Component } from "../extends";

export default () =>
	class Fade extends Component() {
		animations() {
			gsap.set(this.el, {
				y: 40,
				opacity: 0,
			});

			this.anim = gsap.timeline();

			this.anim.to(
				this.el,
				{
					y: 0,
					opacity: 1,
					ease: "sine.out",
					duration: 0.6,
				},
				0.2
			);

			this.anim.seek(0);
			this.anim.play();
		}
	};
